import {
    AUTHENTICATED_USER,
    USER_LOGGED_OUT,
    AGENT_LOGGED_IN,
    CLIENT_LOGGED_IN,
    FREELANCER_LOGGED_IN,
} from '../actions';

const initialState = {
    meta: undefined,
    error: undefined,
    userType: undefined,
    permissions: undefined,
    email: undefined,
    fullName: undefined,
    isAgent: false,
    isClient: false,
    isFreelancer: false,
    isSuperUser: false,
    agency: undefined,
    client: undefined,
    freelancer: undefined,
    loggedIn: false,
};

const unpackUserData = action => ({
    meta: action.payload.meta,
    permissions: action.payload.content.permissions,
    userType: action.payload.content.user_type,
    fullName: action.payload.content.full_name,
    email: action.payload.content.email,
    loggedIn: true,
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATED_USER:
            return {
                ...state,
                ...unpackUserData(action),
                isAgent: action.payload.content.user_type === 'agent',
                isClient: action.payload.content.user_type === 'client',
                isFreelancer: action.payload.content.user_type === 'freelancer',
                isSuperUser: action.payload.content.is_superuser,
            };

        case AGENT_LOGGED_IN:
            return {
                ...state,
                agency: action.payload.content.agency_detail,
                isAgent: true,
            };
        case CLIENT_LOGGED_IN:
            return {
                ...state,
                agency: action.payload.agency_detail,
                client: action.payload,
                isClient: true,
            };
        case FREELANCER_LOGGED_IN:
            return {
                ...state,
                freelancer: action.payload,
                isFreelancer: true,
            };
        case USER_LOGGED_OUT:
            return {
                ...state,
                userType: undefined,
                permissions: undefined,
                email: undefined,
                fullName: undefined,
                isAgent: false,
                isClient: false,
                isFreelancer: false,
                isSuperUser: false,
                client: undefined,
                freelancer: undefined,
                loggedIn: false,
            };
        default:
            return state;
    }
};

export default reducer;
